import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { useQuery } from '@tanstack/react-query';

export interface PolicyDomainAccessResponse {
  canEditAllDomains: boolean;
}

/** Whether the current user may create or save an all-domains policy. */
export function useFetchPolicyDomainAccess() {
  return useQuery({
    queryKey: [api.policyDomainAccess],
    queryFn: () =>
      fetchWrapper.get<PolicyDomainAccessResponse>(api.policyDomainAccess),
  });
}

/**
 * Whether the current user is explicitly allowed to edit all-domain policies.
 * While loading or after an error, access is denied until the server says yes.
 */
export function useCanEditAllGovernanceDomains() {
  const { data, isPending } = useFetchPolicyDomainAccess();

  return {
    canEditAllDomains: data?.canEditAllDomains === true,
    isPending,
  };
}
